import React from 'react'
import { Row, Label, ListGroup, ListGroupItem, Glyphicon, Button } from 'react-bootstrap'
import 'brace/mode/javascript'
import 'brace/theme/github'
import MappingDropdown from '../containers/MappingDropdown'

export default class Context extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      alert: {
        level: null,
        message: null
      },
      contextSearch: ''
    }
  }

  render () {
    return (
      <React.Fragment>
        {this.props.advancedMode && Object.keys(this.props.inputKeys).length > 0 ? <React.Fragment>
          <Row className="flow_border">
            <h3 className="row_heading">Select a primary context</h3>
            <div className="button_wrapper">
              <Button className="green_button" onClick={() => this.props.handleClickUpload(true, false)}　 id="uploadPrimaryContext">
                <Glyphicon glyph="file"/> Upload
              </Button>
            </div>
            <div className="separate">
              <div className="separate__border"/>
              <p className="separate__text">or</p>
              <div className="separate__border"/>
            </div>
            <div>
              {this.props.contextsFromVocabularies && this.props.contextsFromVocabularies.length > 0
                ? <ListGroup　 id="selectPrimaryContext">
                  {this.props.contextsFromVocabularies.map((value, index) => <ListGroupItem key={`item-${index}`}>
                    <input key={index}
                           id={`item-${index}`}
                           value={value.uri}
                           type="radio"
                           checked={this.props.selectedContext.name === value.name}
                           onChange={() => this.props.handleChangeSelectedVocabulary(value, this.props)}/>
                    <label htmlFor={`item-${index}`}>{value.name}</label>
                    <a href={value.uri} target="_blank" className="border_button">
                      <span className="glyphicon glyphicon-new-window"/>Link
                    </a>
                    {value.match.map((v, i) => <Label bsStyle="primary" key={i}  style={{margin:"0 5px"}} >{v.inputKey}</Label>)}
                  </ListGroupItem>)}
                  {this.props.contextsFromGist.map((value, index) => <ListGroupItem key={`item-${index}`} className="bk">
                    <input key={index}
                           value={value.uri}
                           type="radio"
                           checked={this.props.selectedContext.name === value.name}
                           onChange={() => this.props.handleChangeSelectedVocabulary(value, this.props)}/>
                    <label htmlFor={`item-${index}`}>{value.name}</label>
                    <a href={value.uri} target="_blank" className="border_button">
                      <span className="glyphicon glyphicon-new-window"/>Link
                    </a>
                  </ListGroupItem>)}
                </ListGroup>
                : null}
            </div>
          </Row>
          {Object.keys(this.props.inputKeys).length > 0
          && (this.props.selectedContext && this.props.selectedContext.type === 'vocabulary') ? <Row className="flow_border" id="mapping">
            <h3 className="row_heading">Mapping</h3>
            <Row className="mapping_gray_frame">
              {Object.keys(this.props.inputKeys).length > 0 ? Object.keys(this.props.inputKeys).map((v, i) => {
                return (<div key={i} className="mapping_wrapper">
                  <MappingDropdown keyName={v}/>
                </div>)
              }) : null}
            </Row>
          </Row>
          : null}
        </React.Fragment>
        : null}
      </React.Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Context.js